import { useCallback } from 'react';
import type { Track } from 'types/analytics';
import AnalyticsConstants from '../../../../../../../../constants/analytics';
import VendorAnalytics from '../../../../../../../decorators/vendorAnalytics';

const TRACKING_ADD_FAVORITE_PARAMS = {
	type: 'vendor',
	selection: 'mark as booked',
	build_product: 'marketplace',
	source_page: 'storefront',
};

export const useTrackAddToFavorites = (
	vendor: Vendor.Decorated,
	track: Track,
) => {
	return useCallback(() => {
		const vendorAnalytics = new VendorAnalytics(vendor);

		track({
			event: AnalyticsConstants.ADD_TO_FAVORITE,
			properties: {
				type: TRACKING_ADD_FAVORITE_PARAMS.type,
				source_page: TRACKING_ADD_FAVORITE_PARAMS.source_page,
				selection: TRACKING_ADD_FAVORITE_PARAMS.selection,
				build_product: TRACKING_ADD_FAVORITE_PARAMS.build_product,
				...vendorAnalytics.baseEventProps(),
			},
		});
	}, [vendor, track]);
};
